module.exports = __webpack_public_path__ + "img/bg1.675097ff.png";